import styled from 'styled-components';

export const ExpiredLinkStyles = styled.div`
  .expired-link-img {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: auto;
    }
  }
  .expired-link-text {
    text-align: center;
    span,
    a {
      color: ${(props) => props.theme.primary.primary50};
      display: block;
    }
    p {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`;
